import Vue from 'vue'
import debounce from 'lodash/debounce'
import {getQueryStringParam} from '@/helpers/Utils'

import columnContent from './sort-column-default'
Vue.component(columnContent.name, columnContent)

export default {
    slots() {
        return [
            {
                slot: "column-default",
                component: columnContent.name,
                condition(attrs) {
                    if( ! this.displaySort ) {
                        return false
                    }

                    if( attrs.col.sort === false ) {
                        return false
                    }

                    if( this.sort === '*' ) {
                        return true
                    }

                    return attrs.col.field !== undefined && attrs.col.sort || inArray(attrs.col.field, this.sort)
                }
            }
        ]
    },
    mixins() {
        return {
            props: {
                displaySort: {
                    type: Boolean,
                    default: true
                },
                sortUseRouter: {
                    type: Boolean,
                    default: true
                },
                sort: {
                    type: [Array, String],
                    default: () => []
                },
                sortMultiple: {
                    type: Boolean,
                    default: false
                },
                sortParam : {
                    type: String,
                    default: 'sort'
                }
            },
            watch: {
                $route: {
                    immediate: true,
                    handler() {
                        if ( ! this.sortUseRouter ) {
                            return
                        }

                        setTimeout(() => {
                            let hasActiveSort = false
                            let querySortString = getQueryStringParam.bind(this)(this.sortParam)

                            if( querySortString === undefined ) {
                                return
                            }

                            let sortParams = querySortString.split(',')

                            for( let querySort of sortParams ) {
                                let firstChar = querySort.charAt(0)

                                if( firstChar !== '+' && firstChar !== '-' ) {
                                    return
                                }

                                let type = firstChar === '+' ? 'asc' : 'desc'
                                let field = querySort.substr(1)

                                if(inArray(field, this.$_columnsRegister)) {
                                    let changed = false

                                    if( this.conditionsState.sort.has(field) ) {
                                        let found = this.conditionsState.sort.get(field)

                                        if( found.type !== type ) {
                                            changed = true
                                            found.type = type
                                        }
                                    } else {
                                        changed = true

                                        this.conditionsState.sort.set(field, {
                                            field,
                                            type
                                        })
                                    }

                                    if( changed ) {
                                        hasActiveSort = true
                                        this.sortMapChangeTracker++
                                        this.$emit('on-sort', field, type)
                                    }
                                }
                            }

                            if( hasActiveSort ) {
                                this.$emit('change-internal', this.conditionsState)
                            }

                        }, 1)
                    }
                }
            },
            data() {
                return {
                    conditionsState: {},
                    sortMapChangeTracker: 1
                }
            },
            created() {
                Vue.set(this.conditionsState, 'sort', new Map())

                let debounced_onChange = debounce(function(conditions) {
                    this.$emit('change', conditions)
                }.bind(this), 100)

                this.$off('change-internal').$on('change-internal', debounced_onChange)
            }
        }
    }
}
